require('./lib/setup.js');

// CSS
require('../styles/font-awesome/font-awesome.scss');
require('../styles/theme-dusk.scss');
require('../styles/theme-tropic.scss');
require('../styles/theme-emerald.scss');
require('../styles/theme-sand.scss');
require('../styles/theme-rust.scss');
require('../styles/theme-orchid.scss');
require('../styles/theme-ash.scss');
require('../styles/theme-midnight.scss');
require('../styles/main.scss');
require('../styles/font-mono.scss');
require('../styles/font-legacy.scss');
require('../styles/ascii-compact.scss');


//////////////////
// WEBPACK FOOTER
// ./app/src/common.js
// module id = 3dP0
// module chunks = 1